module.exports = __webpack_public_path__ + "static/media/wine-modal.0007f0aa.svg";